import React, { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import MapIcon from '@material-ui/icons/Explore'
import ListIcon from '@material-ui/icons/List'
import { ButtonGroup, Button } from '@material-ui/core'
import { FILTER_MAP_VIEW, FILTER_LIST_VIEW } from 'helpers/seaLice'
import { setActiveMap } from 'reducers/seaLice/reducer'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'

class ContentTypeButtonGroup extends Component {
  onToggleChange = evt => {
    this.props.setActiveMap(evt.currentTarget.value)
  }

  render() {
    const { activeMap } = this.props

    return (
      <div className="toggle-panel">
        <ButtonGroup size={ifWindowWidthLessThan(992) ? 'small' : 'medium'}>
          <Button
            className={cn({ 'active-btn': activeMap === FILTER_MAP_VIEW })}
            value={FILTER_MAP_VIEW}
            onClick={this.onToggleChange}>
            <MapIcon />
          </Button>
          <Button
            className={cn({ 'active-btn': activeMap === FILTER_LIST_VIEW })}
            value={FILTER_LIST_VIEW}
            onClick={this.onToggleChange}>
            <ListIcon />
          </Button>
        </ButtonGroup>
      </div>
    )
  }
}

export default connect(
  state => ({
    activeMap: state.getIn(['seaLice', 'activeMap']),
  }),
  {
    setActiveMap,
  },
)(ContentTypeButtonGroup)
